import { render, staticRenderFns } from "./BlackPinKits.vue?vue&type=template&id=3df70db8&"
import script from "./BlackPinKits.vue?vue&type=script&lang=js&"
export * from "./BlackPinKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports